import './App.css';

import React, { useContext, useEffect, useRef, useState } from 'react';
import { CliContext } from './context/CliContext';

const TypewriterEffect = ({ text }) => {
  const [displayText, setDisplayText] = useState('');
  const [currentCharIndex, setCurrentCharIndex] = useState(0);
  const demoMessageSent = useRef(false);
  // New state variable
  const { badEncountered, typeSpeed, setTypewriterCompleted, convoArray, setConvoArray } = useContext(CliContext);

  
  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentCharIndex((prevIndex) => {
        if (prevIndex === text.length && text.length !==0) {
          // set typing as completed 
          setTypewriterCompleted(true)
          clearInterval(intervalId);
        }
        return prevIndex + 1;
      });
    }, typeSpeed);
    

    return () => {
      clearInterval(intervalId);
    };
  }, [text, typeSpeed, setTypewriterCompleted]);

  useEffect(() => {
    setDisplayText(text.substring(0, currentCharIndex));
  }, [currentCharIndex, text]);


  useEffect(() => {
    if (demoMessageSent.current || convoArray.length > 0 || text.length === 0) {
      return;
    }

    const convoData = {
      by: 'AI',
      timestamp: new Date().toLocaleString(),
      content: "Hi! type 'demo' for showcasing my capabilities!",
    };

    setConvoArray((prevArray) => [...prevArray, convoData]);
    demoMessageSent.current = true;
  }, [convoArray.length, setConvoArray, text]);




  return (
    <div>
    <div className={`typewriter-container ${badEncountered ? 'text-color-red' : ''}`}>
      {displayText.split('').map((char, index) => (
        <span key={index} className="change">
          {char}
        </span>
      ))}
    </div>
     <br/><br/>
     </div>
  );



};

export default TypewriterEffect;
